<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Grupos</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu dos contratos">
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveCustomerGroup('add')"
                      v-b-tooltip.hover
                      title="Novo Grupo!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Grupo
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType !== 'id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="200">Descrição</td>
                      <td nowrap class="text-center align-middle" width="150">Documento</td>
                      <td nowrap class="text-center align-middle" width="80">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.description"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.document"
                        />
                      </td>
                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(group, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ group.id }}</td>
                      <td class="text-left align-middle">
                        {{ group.description }}
                      </td>
                      <td class="text-center align-middle">
                        {{ group.document | cnpj | cpf }}
                      </td>
                      <td nowrap class="text-center align-middle">
                        <a
                          href="#"
                          @click.prevent.stop="openSaveCustomerGroup(group.id, 'put')"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Cadastro"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="confirmDel(group.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Delete"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerGroupsModal v-if="showCustomerGroupSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerGroupSave"
          @click="closeSaveCustomer()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerGroupsModal from '@/components/customers/groups/CustomerGroupsModal';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'CustomerGroups',
  components: { CustomerGroupsModal },
  data() {
    return {
      data: {},
      sortType: localStorage.customerGroupsSortType ? localStorage.customerGroupsSortType : 'id',
      sortReverse: localStorage.customerGroupsSortReverse
        ? localStorage.customerGroupsSortReverse
        : false,
      amount: localStorage.customerGroupsDataAmount ? localStorage.customerGroupsDataAmount : 100,
      page: localStorage.customerGroupsDataPage ? localStorage.customerGroupsDataPage : 1,
      filters: {
        id: localStorage.customerGroupsFilterId ? localStorage.customerGroupsFilterId : '',
        description: localStorage.customerGroupsFilterDescription
          ? localStorage.customerGroupsFilterDescription
          : '',
        document: localStorage.customerGroupsFilteDocument
          ? localStorage.customerGroupsFilterDocument
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerGroupSave() {
      return this.$store.state.showCustomerGroupSave;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.description = '';
      this.filters.document = '';
      this.filters.sortType = 'description';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerGroupsFilterId', this.filters.id);
      localStorage.setItem('customerGroupsFilterDescription', this.filters.description);
      localStorage.setItem('customerGroupsFilterDocument', this.filters.document);
      localStorage.setItem('customerGroupsDataAmount', this.amount);
      localStorage.setItem('customerGroupsDataPage', this.page);
      localStorage.setItem('customerGroupsSortType', this.sortType);
      localStorage.setItem('customerGroupsSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&description=${this.filters.description ? this.filters.description : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/group/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    openSaveCustomerGroup(id, type) {
      this.$store.state.showCustomerGroupSave = id;
      if (id !== 'add') {
        this.$store.state.showActionCustomerGroupSave = type ? type : null;
      }
    },
    closeSaveCustomer() {
      this.$store.state.showCustomerGroupSave = null;
      this.callData();
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir o grupo selecionado?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/group/delete/${id}`;
      axios
        .get(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
